/* ============
 * Create Page
 * ============
 *
 * This page shows transfers.
 */

import { mapGetters } from 'vuex';
import transferService from './../../../../services/transfer';
import batchService from './../../../../services/batch';

export default {
  data() {
    return {
      loading: true,
      tabIndex: 'first',
      currentTransfer: {
        products: [],
        toWarehouse: {
          name: '',
        },
        stock: {
          name: '',
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
      batches: 'allBatches',
    }),
    productList() {
      return this.currentTransfer.products.map((c) => {
        const product = {
          sku: c.productSku,
          name: c.productName,
        };
        if (this.hasProduction) {
          const batchId = c.batchId ? c.batchId : (this.currentTransfer.batchId || null);
          product.batch = batchId ? this.batches.find(b => +b.id === +batchId) : null;
        }
        product.qty = c.qty;
        product.notes = c.notes;

        return product;
      });
    },
    hasProduction() {
      if (this.account.modules.length > 0) {
        return this.account.modules.find(m => m.name.toString() === 'Production');
      }
      if (this.account.allowProducerBatches) return true;
      return false;
    },

  },

  watch: {
    currentTransfer(currentTransfer) {
      // console.log(currentTransfer);
    },
  },

  created() {
    this.loading = false;
  },

  methods: {

    showPrintableDeliveryNote() {
      transferService.showDeliveryNote(this.$route.params.id);
    },

    markAsDone() {
      this.loading = false;
      transferService.markAsDone(this.$route.params.id, [])
        .then(() => {
          this.$message({
            message: this.$t('static.transfer.update.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.transfer.index',
          });
        }).catch((errors) => {});
    },
    markAsDraft() {
      this.loading = false;
      transferService.markAsDraft(this.$route.params.id, [])
        .then(() => {
          this.$message({
            message: this.$t('static.transfer.update.success'),
            type: 'success',
          });
          this.$router.push({
            name: 'inventory.transfer.index',
          });
        }).catch((errors) => {});
    },
  },
  mounted() {
    Promise.all([
      transferService.show(this.$route.params.id),
      batchService.all({
        warehouse_id: '',
        has_warehouse_transaction: 1,
        for_select: 1,
      }),
    ]).then((data) => {
      this.currentTransfer = data[0];
    });
  },
  components: {
    VTable: require('./../../../../components/table/table.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/transfer/view/view.js